import "react-app-polyfill/ie11";			// ie11 support
import "react-app-polyfill/stable";		// ie11 support

import React from 'react'
import ReactDOM from 'react-dom';

import { makeMainRoutes } from './routes';
const routes = makeMainRoutes();

ReactDOM.render(
  	routes,
  	document.getElementById('root'),
);
